import './notification-options-card.css';

export interface NotificationOptionsCardProps {
  className?: string;
  emailMarketing?: boolean;
  figmaNode?: string;
  onToggleEmailMarketing?: () => void;
  onTogglePush?: () => void;
  onToggleSms?: () => void;
  pushEnabled?: boolean;
  smsActiveTransport?: boolean;
}

export function NotificationOptionsCard({
  className = '',
  emailMarketing = false,
  figmaNode = '2680:40926',
  onToggleEmailMarketing,
  onTogglePush,
  onToggleSms,
  pushEnabled = true,
  smsActiveTransport = true,
}: NotificationOptionsCardProps) {
  return (
    <section
      className={`lovo-notification-card ${className}`}
      data-figma-node={figmaNode}
    >
      <h2>Уведомления</h2>
      <div className="lovo-notification-card__list">
        <button
          className={`lovo-notification-card__checkbox-btn ${pushEnabled ? 'is-active' : ''}`}
          type="button"
          onClick={onTogglePush}
        >
          <i />
          <span>Push в браузере</span>
        </button>

        <button
          className={`lovo-notification-card__checkbox-btn ${smsActiveTransport ? 'is-active' : ''}`}
          type="button"
          onClick={onToggleSms}
        >
          <i />
          <span>SMS об активной перевозке</span>
        </button>

        <button
          className={`lovo-notification-card__checkbox-btn ${emailMarketing ? 'is-active' : ''}`}
          type="button"
          onClick={onToggleEmailMarketing}
        >
          <i />
          <span>Email-рассылка</span>
        </button>
      </div>
    </section>
  );
}
